import { FieldGroup } from "@/modules/InfoGroup/models/FieldGroup";

export const ELEMENT_VOIDED = " element-voided";
export const FIELD_PREVIEW_TEXT = "Previsualización de campo";
export const MIN_WIDTH_BASIC_SMALL_FIELD = "min-width: 150px;";
export const MIN_WIDTH_LIST_SMALL_FIELD = "min-width: 200px;";
export const ERROR_NO_LIST_SELECTED = "Debe agregar una lista para el campo";
export const ERROR_NAME_DUPLICATE = "ya se encuentra un campo con este nombre";

export const FIELD_GROUP_INIT: FieldGroup = {
  order: 0,
  type: "",
  list: "",
  key: "",
  conversationTitle: "",
  required: true,
  visible: true,
  editable: true,
  visualElement: "",
  uiSetup: {
    iconUrl: "",
    helpText: ""
  },
  schema: {
    title: "",
    type: ""
  },
  default: false,
  width: 12,
  visibleDashboard: false,
  editableDashboard: false
};

export const NAME_KEY_CHART = {
  LIST_ARRAY: "listArray",
  LIST_ROLE: "roleList"
};
